module.exports = __webpack_public_path__ + "img/new4-img4.f8889517.png";